'use client';

import { useEffect, useState } from 'react';

import TypewriterEffect from 'typewriter-effect';

export const Typewriter = ({ words = [], options = null }) => {
	// Hooks

	// Render
	return (
		<TypewriterEffect
			options={{
				strings: words,
				delay: 60,
				deleteSpeed: 40,
				pauseFor: 1500,
				autoStart: true,
				loop: true,
				wrapperClassName: 'text-foreground-body leading-relaxed',
				cursorClassName: 'text-foreground opacity-25',
				...options,
			}}
		/>
	);
};

export const useTypewriterPlaceholder = ({
	words = [],
	delay = 28,
	deleteSpeed = 8,
	emptyPauseFor = 450,
	initialText = '',
	pauseFor = 1100,
}: {
	words?: string[];
	delay?: number;
	deleteSpeed?: number;
	emptyPauseFor?: number;
	initialText?: string;
	pauseFor?: number;
} = {}) => {
	const [deleting, setDeleting] = useState(false);
	const [text, setText] = useState('');
	const [wordIndex, setWordIndex] = useState(0);

	// Computed
	const signature = words.join('|');

	// Hooks
	useEffect(() => {
		setDeleting(false);
		setText('');
		setWordIndex(0);
	}, [signature]);

	useEffect(() => {
		if (!words.length) return;

		const word = words[wordIndex % words.length] || '';
		const complete = text === word;
		const empty = text === '';
		const timeout =
			empty && deleting ? emptyPauseFor : complete && !deleting ? pauseFor : deleting ? deleteSpeed : delay;

		const timer = window.setTimeout(() => {
			if (complete && !deleting) return setDeleting(true);
			if (empty && deleting) {
				setDeleting(false);
				setWordIndex((wordIndex + 1) % words.length);
				return;
			}

			setText(deleting ? word.slice(0, text.length - 1) : word.slice(0, text.length + 1));
		}, timeout);

		return () => window.clearTimeout(timer);
	}, [delay, deleting, deleteSpeed, emptyPauseFor, pauseFor, text, wordIndex, words, signature]);

	return text || initialText || '';
};

// Docs
// https://www.npmjs.com/package/typewriter-effect
